import * as React from 'react'
import { debounce } from 'debounce';
import { Form, Dropdown, Checkbox, CheckboxProps, InputProps, DropdownProps, ButtonProps, Pagination, PaginationProps } from 'semantic-ui-react';
import { countryOptions, yearOptions, dayOptions, monthOptions, employmentOptions } from '../dropdownOptions';
import { PlanHolder as PlanHolderModel } from '../../../models/applicationForm';

interface PlanHolderInputState {
  currentStep: number,
  surname?: string,
  name?: string,
  dateOfBirthYear?: number | null,
  dateOfBirthMonth?: string,
  dateOfBirthDay?: number | null,
  gender?: string,
  birthPlace?: string,
  birthCountry?: string,
  countriesOfCitizenship?: string[],
  email?: string,
  idType?: string,
  idCountry?: string,
  idNumber?: string,
  streetAddress?: string,
  zipCode?: string,
  city?: string,
  province?: string,
  country?: string,
  govOfficial?: boolean,
  govAssocOfficial?: boolean,
  govEmpOfficial?: boolean,
  govExplanation?: string,
  employmentStatus?: string,
  occupation?: string,
  occupationDuties?: string,
  employerName?: string,
  employerAddress?: string,
  employerBusinessType?: string,
  incomeLevel?: string
}

interface PlanHolderInputProps {
  planholder: PlanHolderModel,
  setPlanholder: (planholder: PlanHolderModel) => object
}

class PlanHolder extends React.Component<PlanHolderInputProps, PlanHolderInputState> {
  constructor(props: PlanHolderInputProps) {
    super(props);

    const dateOfBirthAsDate: Date | null = this.props.planholder.dateOfBirth ?
      new Date(this.props.planholder.dateOfBirth) : null;

    this.state = {
      currentStep: 1,
      surname: this.props.planholder.surname,
      name: this.props.planholder.name,
      dateOfBirthDay: dateOfBirthAsDate ?
        dateOfBirthAsDate.getDate() : null,
      dateOfBirthMonth: dateOfBirthAsDate ?
        monthOptions[dateOfBirthAsDate.getMonth()].text : '',
      dateOfBirthYear: dateOfBirthAsDate ?
        dateOfBirthAsDate.getFullYear() : null,
      gender: this.props.planholder.gender,
      birthPlace: this.props.planholder.birthPlace,
      birthCountry: this.props.planholder.birthCountry,
      countriesOfCitizenship: this.props.planholder.countriesOfCitizenship,
      email: this.props.planholder.email,
      idType: this.props.planholder.idType,
      idCountry: this.props.planholder.idCountry,
      idNumber: this.props.planholder.idNumber,
      streetAddress: this.props.planholder.streetAddress,
      zipCode: this.props.planholder.zipCode,
      city: this.props.planholder.city,
      country: this.props.planholder.country,
      govOfficial: this.props.planholder.govOfficial,
      govAssocOfficial: this.props.planholder.govAssocOfficial,
      govEmpOfficial: this.props.planholder.govEmpOfficial,
      govExplanation: this.props.planholder.govExplanation,
      employmentStatus: this.props.planholder.employmentStatus,
      occupation: this.props.planholder.occupation,
      occupationDuties: this.props.planholder.occupationDuties,
      employerName: this.props.planholder.employerName,
      employerAddress: this.props.planholder.employerAddress,
      employerBusinessType: this.props.planholder.employerBusinessType,
      incomeLevel: this.props.planholder.incomeLevel
    };

    this.setPlanholder = debounce(this.setPlanholder,500);
  }

  public render() {
    return (
      <div className='application-form-wrap'>
        <h6>Section 2 - Step {this.state.currentStep}</h6>
        <h1>INDIVIDUAL PLAN HOLDER</h1>
        <Form>
          {/* Step 1 Personal info */ }
          { this.state.currentStep === 1 &&
            <div className='card'>
              <p>
                This section should be completed only by individuals taking out a Sanlam Global Investment Plan in their own name.
              </p>
              <p>
                Maximum of ten Plan holders per Plan. If more than two Plan holders are requested, please attach a further copy of this page to the application.
              </p>
            <Form.Input
              fluid={true}
              name='surname'
              label='Surname'
              placeholder='Surname'
              value={this.state.surname}
              onChange={this.handleInputChange}
            />
            <Form.Input
              fluid={true}
              name='name'
              label='Full first and middle names'
              placeholder='Full first and middle names'
              value={this.state.name}
              onChange={this.handleInputChange}
            />
            <Form.Input fluid={true} label='Date of birth'>
              <Form.Select
                compact={true}
                name='dateOfBirthDay'
                options={dayOptions}
                value={this.state.dateOfBirthDay ? this.state.dateOfBirthDay.toString() : ''}
                onChange={this.handleDropdownChange}
              />
              <Form.Select
                compact={true}
                name='dateOfBirthMonth'
                options={monthOptions}
                value={this.state.dateOfBirthMonth}
                onChange={this.handleDropdownChange}
              />
              <Form.Select
                compact={true}
                name='dateOfBirthYear'
                options={yearOptions}
                value={this.state.dateOfBirthYear ? this.state.dateOfBirthYear.toString() : ''}
                onChange={this.handleDropdownChange}
              />
            </Form.Input>
            <Form.Input fluid={true} label='Identification type'>
              <Form.Field>
                <Checkbox
                  radio={true}
                  label='Passport'
                  name='idType'
                  value='Passport'
                  checked={this.state.idType === 'Passport'}
                  onChange={this.handleRadioButtonChange}
                />
              </Form.Field>
              <Form.Field>
                <Checkbox
                  radio={true}
                  label='ID Card'
                  name='idType'
                  value='IDCard'
                  checked={this.state.idType === 'IDCard'}
                  onChange={this.handleRadioButtonChange}
                />
              </Form.Field>
            </Form.Input>
            <Form.Input fluid={true} label='Country of issue'>
              <Dropdown
                placeholder='Select Country'
                fluid={true}
                search={true}
                selection={true}
                options={countryOptions}
                name='idCountry'
                value={this.state.idCountry}
                onChange={this.handleDropdownChange}
              />
            </Form.Input>
            <Form.Input
              name='idNumber'
              label='Passport/ID number'
              placeholder='Passport/ID number'
              value={this.state.idNumber}
              onChange={this.handleInputChange}
            />
            <Form.Input
            name='streetAddress'
            label='Street address'
            placeholder='Street address'
            width={13}
            value={this.state.streetAddress}
            onChange={this.handleInputChange}
            />
            <Form.Input
            name='city'
            label='City'
            placeholder='City'
            value={this.state.city}
            onChange={this.handleInputChange}
            />
            <Form.Input
            name='province'
            label='Province'
            placeholder='Province'
            value={this.state.province}
            onChange={this.handleInputChange}
            />
            <Form.Input fluid={true} label='Country'>
            <Dropdown
            placeholder='Select Country'
            fluid={true}
            search={true}
            selection={true}
            options={countryOptions}
            name='country'
            value={this.state.country}
            onChange={this.handleDropdownChange}
            />
            </Form.Input>
            <Form.Input
            name='zipCode'
            label='Zip/postal code'
            placeholder='Zip/postal code'
            width={3}
            value={this.state.zipCode}
            onChange={this.handleInputChange}
            />
            <Form.Input
              name='email'
              label='Email address'
              placeholder='Email address'
              value={this.state.email}
              onChange={this.handleInputChange}
            />
            <Form.Input fluid={true} label='Gender'>
            <Form.Field>
              <Checkbox
                radio={true}
                label='Male'
                name='gender'
                value='Male'
                checked={this.state.gender === 'Male'}
                onChange={this.handleRadioButtonChange}
              />
            </Form.Field>
            <Form.Field>
            <Checkbox
              radio={true}
              label='Female'
              name='gender'
              value='Female'
              checked={this.state.gender === 'Female'}
              onChange={this.handleRadioButtonChange}
            />
            </Form.Field>
            </Form.Input>
            <Form.Input fluid={true} label='Countries of citizenship'>
            <Dropdown
            placeholder='Add all that apply'
            fluid={true}
            search={true}
            selection={true}
            multiple={true}
            options={countryOptions}
            name='countriesOfCitizenship'
            value={this.state.countriesOfCitizenship}
            onChange={this.handleDropdownChange}
            />
            </Form.Input>

            <Form.Button fluid={true} onClick={this.next}>Next</Form.Button>
            </div>
          }
          {/* Step 2 Gov association info */ }
          { this.state.currentStep === 2 &&
            <div className='card'>
              <Form.Input className={`toggle-button-wrap ${this.state.govOfficial ? 'isChecked': 'isUnChecked'}`} fluid={true} label='Are you now or have you been a government official?'>
                <Form.Button className={'toggle-button yes'} name='govOfficial' value={true} onClick={this.handleButtonToggleChange}>Yes</Form.Button>
                <Form.Button className={'toggle-button no'} name='govOfficial' value={false} onClick={this.handleButtonToggleChange}>No</Form.Button>
              </Form.Input>
              <Form.Input className={`toggle-button-wrap ${this.state.govAssocOfficial ? 'isChecked': 'isUnChecked'}`} fluid={true} label='Are you now or have you been associated with a government official?'>
                <Form.Button className={'toggle-button yes'} name='govAssocOfficial' value={true} onClick={this.handleButtonToggleChange}>Yes</Form.Button>
                <Form.Button className={'toggle-button no'} name='govAssocOfficial' value={false} onClick={this.handleButtonToggleChange}>No</Form.Button>
              </Form.Input>
              <Form.Input className={`toggle-button-wrap ${this.state.govEmpOfficial ? 'isChecked': 'isUnChecked'}`} fluid={true} label='Are you now or have you been employed by a state owned agency/company?'>
                <Form.Button className={'toggle-button yes'} name='govEmpOfficial' value={true} onClick={this.handleButtonToggleChange}>Yes</Form.Button>
                <Form.Button className={'toggle-button no'} name='govEmpOfficial' value={false} onClick={this.handleButtonToggleChange}>No</Form.Button>
              </Form.Input>
              {
                (this.state.govOfficial || this.state.govAssocOfficial || this.state.govEmpOfficial) &&
                <Form.Input
                  name='govExplanation'
                  fluid={true}
                  label='You have answered yes to one or more of the above questions, please explain'
                  value={this.state.govExplanation}
                  onChange={this.handleInputChange}
                />
              }
              <Form.Button fluid={true} onClick={this.next}>Next</Form.Button>
            </div>
          }

          {/* Step 3 Employment info */ }
          { this.state.currentStep === 3 &&
            <div className='card'>
              <Form.Input fluid={true} label='Employment status'>
                <Dropdown
                  placeholder='Employment status'
                  fluid={true}
                  selection={true}
                  options={employmentOptions}
                  name='employmentStatus'
                  value={this.state.employmentStatus}
                  onChange={this.handleDropdownChange}
                />
              </Form.Input>
              <Form.Input
                name='occupation'
                label='Occupation'
                placeholder='Occupation'
                value={this.state.occupation}
                onChange={this.handleInputChange}
              />
              <Form.Input
                name='employerName'
                label='Name of employer'
                placeholder='Name of employer'
                value={this.state.employerName}
                onChange={this.handleInputChange}
              />
              <Form.Input
                name='employerAddress'
                label='Address of employer'
                placeholder='Address of employer'
                value={this.state.employerAddress}
                onChange={this.handleInputChange}
              />
              <Form.Input
                name='occupationDuties'
                label='Your Title and Duties/Responsibilities'
                placeholder='Your Title and Duties/Responsibilities'
                value={this.state.occupationDuties}
                onChange={this.handleInputChange}
              />
              <Form.Input
                name='employerBusinessType'
                label='Type of business'
                placeholder='Describe Company/Employers type of business'
                value={this.state.employerBusinessType}
                onChange={this.handleInputChange}
              />
              <Form.Input fluid={true} label='Annual income level'>
                <Form.Field>
                  <Checkbox
                    radio={true}
                    label='USD 50,000-100,000'
                    name='incomeLevel'
                    value='50000_to_100000'
                    checked={this.state.incomeLevel === '50000_to_100000'}
                    onChange={this.handleRadioButtonChange}
                  />
                </Form.Field>
                <Form.Field>
                  <Checkbox
                    radio={true}
                    label='USD 100,000 - 500,000'
                    name='incomeLevel'
                    value='100000_to_500000'
                    checked={this.state.incomeLevel === '100000_to_500000'}
                    onChange={this.handleRadioButtonChange}
                  />
                </Form.Field>
                <Form.Field>
                  <Checkbox
                    radio={true}
                    label='USD 500,000 +'
                    name='incomeLevel'
                    value='500000_plus'
                    checked={this.state.incomeLevel === '500000_plus'}
                    onChange={this.handleRadioButtonChange}
                  />
                </Form.Field>
              </Form.Input>

              <Form.Button fluid={true} onClick={this.next}>Next</Form.Button>
            </div>
          }

          {/* Step 4 Tax residence info */}
          { this.state.currentStep === 4 &&
            <div className='card'>
              <h5>Tax Residence Information</h5>
              <p>Please complete the following table indicating (i) the country where the Plan holder is resident for tax purposes and (ii) the Plan holder’s Taxpayer Identification Number or tax resident country’s functional equivalent (hereafter referred to as “Resident Country(ies) TIN”) for each country indicated.</p>
              <p>If the Plan holder is a resident for tax purposes in more than three countries, please use a separate sheet.</p>

              <p>If a Resident Country(ies) TIN is unavailable please provide reason A, B or C where appropriate:</p>

              <h5>Reason A</h5>
              <p>The country where the Plan holder is liable to pay tax does not issue Resident Country(ies) TINs to its residents</p>

              <h5>Reason B</h5>
              <p>The Plan holder is otherwise unable to obtain a Resident Country(ies) TIN (please explain why Plan holder is unable to obtain a Resident Country(ies) TIN in the below table if you have selected this reason)</p>

              <h5>Reason C</h5>
              <p>No Resident Country(ies) TIN is required (note: only select this reason if the authorities of the country of residence for tax purposes entered below do not require the Resident Country(ies) TIN to be disclosed)</p>
              <Form.Input
                name='birthPlace'
                label='City/Place of Birth'
                placeholder='City/Place of Birth'
                value={this.state.birthPlace}
                onChange={this.handleInputChange}
              />

              <Form.Input fluid={true} label='Country of birth'>
                <Dropdown
                  placeholder='Select Country'
                  fluid={true}
                  search={true}
                  selection={true}
                  options={countryOptions}
                  name='birthCountry'
                  value={this.state.birthCountry}
                  onChange={this.handleDropdownChange}
                />
              </Form.Input>

              <Form.Button fluid={true} onClick={this.next}>Next</Form.Button>
            </div>
          }

          { /* Step 5 Uploads */ }
          { this.state.currentStep === 5 &&
            <div className='card'>
              <h5>Document uploads</h5>
              Proof of id<br />
              Proof of address<br/><br/>

              <h5>Document uploads</h5>
              Proof of Source of funds<br />
              Proof of Address<br />
              Wire transmittal Form<br/><br/>

              <Form.Button onClick={this.handleSubmit}>Submit</Form.Button>
            </div>
          }

          <Pagination
            className='application-form-pagination'
            activePage={this.state.currentStep}
            onPageChange={this.handlePaginationChange}
            totalPages={5}
            firstItem={null}
            lastItem={null}
            prevItem={null}
            nextItem={null}
          />

        </Form>
      </div>
    )
  }

  private handleRadioButtonChange = (event: React.SyntheticEvent<HTMLElement, Event>, radioButton: CheckboxProps) => {
    this.handleChange(radioButton.name, radioButton.value);
  }

  private handleButtonToggleChange = (event: React.SyntheticEvent<HTMLElement, Event>, button: ButtonProps) => {
    this.handleChange(button.name, button.value);
  }

  private handleInputChange = (event: React.SyntheticEvent<HTMLElement, Event>, input: InputProps) => {
    this.handleChange(input.name, input.value);
  }

  private handleDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, dropDown: DropdownProps) => {
    this.handleChange(dropDown.name, dropDown.value);
  }

  private handlePaginationChange = (event: React.MouseEvent<HTMLAnchorElement>, pagination: PaginationProps) => {
    this.handleChange('currentStep', pagination.activePage);
   }

  private next = () => this.setState({ currentStep: this.state.currentStep + 1});

  private handleChange = (key: any, value: any) => {
    this.setState({
      [key]: value
    } as PlanHolderInputState, () => {
      this.setPlanholder();
    });
  }

  private handleSubmit = (event: React.FormEvent<HTMLButtonElement>, button: ButtonProps) => {
    event.preventDefault();

    // TODO => Submit info
  }

  private setPlanholder = () => {
    this.props.setPlanholder(this.mapStateToPlanholder());
  }

  private mapStateToPlanholder = () : PlanHolderModel => ({
    surname: this.state.surname || '',
    name: this.state.name || '',
    dateOfBirth: parseInt(new Date(`${this.state.dateOfBirthDay}-${this.state.dateOfBirthMonth}-${this.state.dateOfBirthYear}`)
      .getTime().toFixed(0), 10),
    gender: this.state.gender || '',
    birthPlace: this.state.birthPlace || '',
    birthCountry: this.state.birthCountry || '',
    countriesOfCitizenship: this.state.countriesOfCitizenship || [],
    email: this.state.email || '',
    idType: this.state.idType || '',
    idCountry: this.state.country || '',
    idNumber: this.state.idNumber || '',
    streetAddress: this.state.streetAddress || '',
    zipCode: this.state.zipCode || '',
    city: this.state.city || '',
    province: this.state.province || '',
    country: this.state.country || '',
    govOfficial: this.state.govOfficial || false,
    govEmpOfficial: this.state.govEmpOfficial || false,
    govAssocOfficial: this.state.govAssocOfficial || false,
    govExplanation: this.state.govExplanation || '',
    employmentStatus: this.state.employmentStatus || '',
    occupation: this.state.occupation || '',
    occupationDuties: this.state.occupationDuties || '',
    employerName: this.state.employerName || '',
    employerAddress: this.state.employerAddress || '',
    employerBusinessType: this.state.employerBusinessType || '',
    incomeLevel: this.state.incomeLevel || ''
  });
}

export default PlanHolder;
